<template>
  <v-container
    fluid
    id="middle-content"
    tag="section"
    class="bounceUp-enter-active"
  >
    <v-img
      :src="require('@/assets/contactUs/contact-us.jpg')"
      max-height="500"
      aspect-ratio="1.7"
      gradient="to top right, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)"
    ></v-img>
    <v-row dense>
      <contact-us></contact-us>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  // import IconApp from '../svg/App'
  import { getCookie } from "../utils/cookie"

  export default {
    components: {
      ContactUs: () => import('@/components/home/ContactUs')
    },

    data: function () {
      return {
        cardElevation: 0,
        currentLanguage: 'zh-hans'
      }
    },

    mounted() {
      let cookieLanguage = getCookie('drupal:session:language')
      if (cookieLanguage) {
        this.currentLanguage = cookieLanguage
      }
    },

    methods: {}
  }
</script>

<style lang="scss" scoped>
  #middle-content {
    float: none;
    position: relative;

    & > div {
      margin: 0 auto;
    }

    @media screen and (max-width: 640px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }

    .col {
      border-radius: 8px;
      background: #fff;
      margin-top: 0px;
      margin-bottom: 10px;
      /*padding: 0 100px;*/
      font-size: 16px !important;

      h1 {
        /*padding: 60px 100px 30px;*/

        a {
          text-transform: capitalize;
        }
      }

      .v-icon {
        border-radius: 20px;
        margin-right: 20px;
        color: #fff;
        top: -2px;
      }

      .icon {
        width: 64px;
        height: 64px;
        max-width: 64px;
        max-height: 64px;
        margin: 100px auto 60px;
        float: none;
        display: block;
      }
    }

    .about-us {
      padding: 0 50px;

      h1 {
        padding: 10px 0;
        margin-top: 17px;
      }

      .icon-with-text {
        display: flex;
        align-items: center;

        .text {
          flex: 1;
        }
      }

      .buy-link {
        padding: 10px 0;
        margin-top: 25px;
      }

      .footer-welcome-wrapper {
        padding: 0;

        .footer-welcome {

          .wechat-image {

            @media screen and (max-width: 480px) {
              margin: 0 auto;
            }
          }
        }
      }

      @media screen and (max-width: 480px) {
        padding: 0 25px 20px;
      }
    }

    .introduce {
      padding: 0 50px;

      h1 {
        padding: 20px 0;
      }

      .special-color {
        color: #004a96;
      }

      @media screen and (max-width: 480px) {
        padding: 0 25px;
      }
    }

    .unlock {
      background-color: #fff;
      border-radius: 8px;
      display: inline-block;
      float: left;
      padding: 10px 3%;
      width: 100%;
      box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, .1);
      margin-bottom: 50px;
      padding-bottom: 50px !important;
    }
  }
</style>
